import ReactCountryFlag from 'react-country-flag';
import styled from 'styled-components';

export const CountryFlag = styled(ReactCountryFlag)`
  font-size: ${({ theme }) => theme.fontSizes[30]} !important;
  line-height: 21px !important;
  margin-right: ${({ theme }) => theme.spacing[8]};
`;
